import { render } from "./basic-info-request.vue?vue&type=template&id=0e59685b&scoped=true"
import script from "./basic-info-request.vue?vue&type=script&lang=js"
export * from "./basic-info-request.vue?vue&type=script&lang=js"

import "./basic-info-request.vue?vue&type=style&index=0&id=0e59685b&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e59685b"]])

export default __exports__